import { render, staticRenderFns } from "./index.vue?vue&type=template&id=adec6afc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=adec6afc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adec6afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adec6afc')) {
      api.createRecord('adec6afc', component.options)
    } else {
      api.reload('adec6afc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=adec6afc&scoped=true", function () {
      api.rerender('adec6afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cc-appt-results/index.vue"
export default component.exports